import React, { FC, useContext } from 'react';

import { COLORS } from '../../config/designSystem/Colors';
import { NavigationMenuVisibilityContext } from './NavigationMenuVisibilityContext';
import { SPACING } from '../../config/designSystem/Spacing';
import { View, useWindowDimensions } from 'react-native';
import { useTabBarHeight } from './TabBarHeightContext';



interface NavigationTabBarProp {
  tabs: React.ReactNode[];
}

export const PADDING_HORIZONTAL_TAB_BAR = SPACING['sp-8'];

const NavigationTabBar: FC<NavigationTabBarProp> = ({tabs}) => {
  const {width} = useWindowDimensions();
  const { visible } = useContext(NavigationMenuVisibilityContext);
  const nbTabs = tabs?.length;
  const {  setTabBarHeight } = useTabBarHeight();
  const dim = (width - 2*PADDING_HORIZONTAL_TAB_BAR)/nbTabs;

  if (!visible) {
    return null;
  }
  return (
    <View style={{
      position:'absolute',
      bottom:0,
      paddingTop:SPACING['sp-12'],
      paddingBottom: SPACING['sp-32'],
      left:0,
      width: '100%',
      paddingHorizontal: PADDING_HORIZONTAL_TAB_BAR,
      flexDirection: 'row',
      backgroundColor: COLORS.surface.primary
    }}
    onLayout={event => {
      // Capture the layout of the tab bar (height)
      const { height } = event.nativeEvent.layout;
      setTabBarHeight(height);  // Update context with the actual height
    }}>

      {tabs.map((tab, index) => {
        return (
          <View key={index} style={{
            flex:1,
            marginHorizontal:SPACING['sp-8'],
            width:dim
          }}>
            {tab}
          </View>
        );
      })
      }

    </View>  );
};



export default NavigationTabBar;